import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketStatusForm from '@/modules/ticket_status/components/TicketStatusForm.vue';
import { TicketStatus } from '@/modules/ticket_status/TicketStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketStatusCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const ticketStatus = ref<Partial<TicketStatus>>({
	content: [],
});

const saved = (ticket_status) => {
	Flash.success($gettext('Status tillagd'));
	router.push({
		name: 'ticket_status.edit',
		params: { id: ticket_status.id },
	});
};

const cancel = () => {
	router.push({ name: 'ticket_status.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TicketStatusForm, {
    "page-title": _unref($gettext)('Ny status'),
    "ticket-status": ticketStatus.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "ticket-status"]))
}
}

})